module.exports = __webpack_public_path__ + "media/images/IMG2-temp_usecases-cf61ae03.png";